import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-scroll',
    templateUrl: './scroll.component.html',
    styleUrls: ['./scroll.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScrollComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
